/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown, DropdownToggle, Button,
  DropdownMenu, Row, Col, Modal, Label,
} from 'reactstrap';
import SimpleBar from 'simplebar-react';

// Import images
import { withTranslation } from 'react-i18next';

import {
  Formik, Field, Form,
} from 'formik';
import * as Yup from 'yup';
import { get, post } from '../../../helpers/api_helper';
import * as url from '../../../helpers/url_helper';
import { formatTime } from '../../../utilities/timeFormat';

function NotificationDropdown(props) {
  const { t } = props;
  const [menu, setMenu] = useState(false);
  const [notices, setNotices] = useState([]);
  const [unread, setUnread] = useState(0);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const [sw, setSw] = useState({
    web: true, email: false, slack: false,
  });

  const mountedRef = useRef(false);
  const timeout = useRef(null); // Changed type to `null` instead of `false`
  const simpleBarRef = useRef(null);

  // eslint-disable-next-line no-unused-vars
  const user = JSON.parse(localStorage.getItem('authUser'));

  // eslint-disable-next-line no-unused-vars
  async function getNotifications() {
    try {
      const result = await get(`${url.GET_NOTIFICATIONS}?per=10&dir=desc&filter=user_id=${user.id}`);

      // If component is still mounted, update state and reset the timeout
      if (mountedRef.current) {
        let unreadCount = 0;
        for (let i = 0; i < result.total; i += 1) {
          if (result.results[i] && result.results[i].seen_at === null) {
            unreadCount += 1;
          }
        }

        setNotices(result.results);
        setUnread(unreadCount);

        // Clear previous timeout if it exists
        if (timeout.current) {
          clearTimeout(timeout.current);
        }

        // Set a new timeout for 60 seconds
        timeout.current = setTimeout(getNotifications, 60000);
      }
    } catch (e) {
      // Handle error (optional)
    }
  }

  async function handleAck(n) {
    try {
      const data = {
        id: n.id,
        user_id: n.user_id,
        acknowledged_at: (new Date()).toISOString().slice(0, 19).replace('T', ' '),
      };

      await post(`${url.POST_NOTIFICATION}`, data);
      getNotifications();
    } catch (e) {
      // do nothing
    }
  }

  const ValidationSchema = Yup.object().shape({
    switches: Yup.object().shape({
      email: Yup.boolean(), // Use Yup.boolean() for checkboxes
      slack: Yup.boolean(),
      web: Yup.boolean(),
      // Add more properties for other checkboxes as needed
    }),
    context: Yup.string().required(),
  });

  const changeNoticeSettings = async (values) => {
    try {
      await post('/api/notify/setting', values);

      setSettingsModalOpen(false);
    } catch (e) {
      // e
    }
  };

  const handleScroll = () => {
    const visibleNotifications = notices.filter((x) => {
      const notificationElement = document.getElementById(`notification_${x.id}`);
      if (notificationElement) {
        const rect = notificationElement.getBoundingClientRect();
        return rect.top > 0 && rect.bottom < 353;
      }
      return false;
    });

    // Mark visible notifications as seen
    visibleNotifications.forEach(async (notification) => {
      try {
        const data = {
          id: notification.id,
          user_id: notification.user_id,
          seen_at: (new Date()).toISOString().slice(0, 19).replace('T', ' '),
        };

        await post(`${url.POST_NOTIFICATION}`, data);
      } catch (e) {
        // Handle error (optional)
      }
    });

    const unreadCount = notices.filter((notice) => notice.seen_at === null).length;
    setUnread(unreadCount);
  };

  const toggle = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    if (simpleBarRef.current) {
      const scrollElement = simpleBarRef.current.getScrollElement();
      scrollElement.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        scrollElement.removeEventListener('scroll', handleScroll);
      };
    }

    return undefined;
  }, [menu]); // Re-run when `menu` changes

  useEffect(() => {
    mountedRef.current = true;
    getNotifications(); // Initial fetch

    return () => {
      mountedRef.current = false;
      if (timeout.current) {
        clearTimeout(timeout.current); // Clear timeout on unmount
      }
    };
  }, []); // Empty dependency array to only run on mount/unmount

  useEffect(() => {
    const getSwitches = async () => {
      try {
        const swi = await get(`/api/notify/switches?context=${modalObj.context}`);
        setSw(swi);
      } catch (error) {
        // Handle error (optional)
      }
    };

    if (modalObj != null) getSwitches();
  }, [modalObj]);

  return (
    <>
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <>
            {unread > 0 && (
              <>
                <i className="bx bx-bell bx-tada" />
                <span className="badge bg-danger rounded-pill">{unread}</span>
              </>
            )}
            {unread === 0 && (
              <i className="bx bx-bell" />
            )}
          </>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">
                  {' '}
                  {t('Notifications')}
                  {' '}
                </h6>
              </Col>
              <div className="col-auto">
                <a href="/notify" className="small">
                  {' '}
                  View All
                </a>
              </div>
            </Row>
          </div>
          <SimpleBar ref={simpleBarRef} style={{ minHeight: '100px', maxHeight: '230px' }}>
            {notices.length === 0 && (
              <div className="text-center text-muted mt-4">
                {t('All caught up')}
              </div>
            )}
            {notices.map((x) => (
              <div id={`notification_${x.id}`} key={`message_${x.id}`}>
                <Link
                  to={x.link === null ? '#' : x.link}
                  className="position-relative text-reset notification-item"
                  onClick={() => { handleAck(x); }}
                >
                  <div className={`d-flex ${x.acknowledged_at === null ? x.class : ''}`}>
                    <div className="avatar-xs me-3">
                      <span className="avatar-title bg-dark rounded-circle font-size-16">
                        <i className="mdi mdi-air-horn" />
                      </span>
                    </div>
                    <div className="flex-grow-1" style={{ maxWidth: '15rem' }}>
                      <h6 className="mt-0 mb-1">
                        {t(x.title)}
                      </h6>
                      <div className="font-size-12 text-dark">
                        <p className="mb-1">
                          {t(x.message)}
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />
                          {' '}
                          {formatTime(x.created_at)}
                          {' '}
                        </p>
                      </div>
                      <div className="position-absolute" style={{ bottom: '0px', right: '0px' }}>
                        <Button
                          color="light"
                          className="text-dark btn-link"
                          onClick={(e) => {
                            e.preventDefault();
                            setSettingsModalOpen(true);
                            setModalObj(x);
                          }}
                        >
                          <span className="bx bx-cog" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="/notify">
              <i className="mdi mdi-arrow-right-circle me-1" />
              {' '}
              <span key="t-view-more">{t('View More..')}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>

      <Modal
        size="sm"
        isOpen={settingsModalOpen}
      >
        <div className="modal-header">
          <h5
            className="modal-title mt-0"
          >
            {t('Edit Notification Settings')}
          </h5>
          <button
            onClick={() => setSettingsModalOpen(false)}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>{t('Edit notification settings for this type of notification specifically below')}</p>

          <Formik
            enableReinitialize
            initialValues={{
              context: modalObj.context,
              switches: sw,
            }}
            validationSchema={ValidationSchema}
            onSubmit={changeNoticeSettings}
          >
            {({ setFieldValue, values }) => (
              <Form className="mt-3" id="edit_notice_settings" autoComplete="off">
                <Field type="hidden" name="context" />
                <div className="form-check form-check-primary mb-3">
                  <Field
                    type="checkbox"
                    id="switches_web"
                    name="switches.web"
                    className="form-check-input"
                    onClick={() => { setFieldValue('switches.web', !values.switches.web); }}
                  />
                  <Label className="form-check-label" for="switches_web">{t('On-screen notice')}</Label>
                </div>

                <div className="form-check form-check-primary mb-3">
                  <Field
                    type="checkbox"
                    id="switches_email"
                    name="switches.email"
                    className="form-check-input"
                    onClick={() => { setFieldValue('switches.email', !values.switches.email); }}
                  />
                  <Label className="form-check-label" for="switches_email">{t(`Send an email to ${user.email}`)}</Label>
                </div>

                <div className="form-check form-check-primary mb-3">
                  <Field
                    type="checkbox"
                    id="switches_slack"
                    name="switches.slack"
                    className="form-check-input"
                    onClick={() => { setFieldValue('switches.slack', !values.switches.slack); }}
                  />
                  <Label className="form-check-label" for="switches_slack">{t('Send me a message on Slack')}</Label>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => setSettingsModalOpen(false)}
            className="btn btn-soft-dark"
            data-dismiss="modal"
          >
            {t('Cancel')}
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            form="edit_notice_settings"
          >
            {t('Save Changes')}
          </button>
        </div>
      </Modal>
    </>
  );
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(NotificationDropdown);
